<template>
    <v-card class="my-2">
        <div class="d-flex justify-space-between">
            <span class="t-subtitle">Método de Pagamento</span>
            <span>{{ plan.payment_method }}</span>
        </div>

        <div class="d-flex justify-space-between mt-3">
            <span class="t-subtitle">
                {{ plan.name }}
            </span>
        </div>
        <ul>
            <template v-for="module in modules">
                <li :key="module.id" class="d-flex justify-space-between">
                    <span>
                        {{ module.price_type != 'flat' ? module.amount + ' ' + module.name : module.name }}
                    </span>
                    <span v-if="!hideModulePrices">
                        {{ module.priceBr }}
                    </span>
                </li>
                <li v-if="module.valid_until" :key="key('valid', module.id)" class="d-flex justify-space-between font-italic caption pb-2">
                    <span>
                        {{ module.price_type != 'flat' ? module.amount_valid_until : '' }} valido até {{ module.validUntil }}
                    </span>
                    <span class="red--text lighten-3">
                        -{{ module.priceValidUntil }}
                    </span>
                </li>
            </template>
        </ul>
        <div class="text-right my-1">
            <strong>Valor total:</strong> {{ plan.regularPriceBr }} / mês
        </div>
        <template v-if="hasDiscount">
            <div class="text-right my-1">
                <strong>Valor com desconto:</strong> {{ plan.finalPriceBr }} / mês
            </div>
            <div class="text-right my-1">
                <strong>Desconto ativo até:</strong> {{ plan.discountDueAt }}
            </div>
        </template>
    </v-card>
</template>

<script>
export default {
    props: {
        plan: {
            type: Object,
            require: true,
        },
        hideModulePrices: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        modules() {
            return _.filter(this.plan.modules, module => {
                return module.type != 'base_price'
            });
        },

        hasDiscount() {
            return this.plan.regular_price > this.plan.final_price
        }
    },

    methods: {
        key(prefix, id) {
            return `${prefix}${id}`
        }
    },
}
</script>

<style>

</style>